export default __webpack_public_path__ + "static/media/709.2cce7293.svg";